var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231 30",
    preserveAspectRatio: "xMinYMid"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.59 19.52h15.24l-8.05-13L91.98 30h-6.73l18-28.17a4.29 4.29 0 017-.05L128.3 30h-6.73l-3.17-5.25h-15.42l-3.36-5.23m69.93 5.23V.28h-5.72v26.88a2.76 2.76 0 00.85 2 2.89 2.89 0 002.08.87h26l3.39-5.25h-26.63m-94.54-4.4a10.05 10.05 0 000-20.1h-25V30h5.71V5.54h18.94a4.81 4.81 0 010 9.62H58.52L75.58 30h8.29l-11.46-9.62h2.57M14.86 30h17.27a14.86 14.86 0 000-29.71H14.86a14.86 14.86 0 100 29.71m16.88-5.23h-16.5a9.62 9.62 0 010-19.23h16.5a9.62 9.62 0 110 19.23M140.23 30h17.63l3.34-5.23h-20.58a9.62 9.62 0 110-19.23h16.75l3.38-5.25h-20.52a14.86 14.86 0 100 29.71m69.87-5.23a9.62 9.62 0 01-9.26-7h24.42l3.36-5.24h-27.78a9.61 9.61 0 019.26-7h16.76l3.35-5.25h-20.5a14.86 14.86 0 000 29.71h17.63l3.35-5.23h-20.6",
    fill: "#c74634"
  })));
}

export default SvgIcon;